import { render } from "./AutocompleteNameSAP.vue?vue&type=template&id=20530c0a&scoped=true"
import script from "./AutocompleteNameSAP.vue?vue&type=script&lang=js"
export * from "./AutocompleteNameSAP.vue?vue&type=script&lang=js"

import "./AutocompleteNameSAP.vue?vue&type=style&index=0&id=20530c0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20530c0a"

export default script